import { useState } from "react";
import { Grid, Button, CircularProgress } from "@mui/material";
import { getLabelsUrl, mergePDFSFromUrls } from "../../utils/labelService";
import DownloadIcon from "@mui/icons-material/Download";


const DownloadAllLabels = ({
  user,
  startDate,
  endDate,
  companyFilter,
  search,
  statusFilter,
  orderFilter,
  orderByFilter,
  page,
  rowsPerPage,
  setErrorOnRetrieveData,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    setIsLoading(true);
    try {
      const filters = {
        startDate,
        endDate,
        companyFilter,
        search,
        statusFilter,
        orderFilter,
        orderByFilter,
        page,
        rowsPerPage,
      };

      const labelUrls = await getLabelsUrl(filters, user);
      if (labelUrls && labelUrls.length > 0) {
        const mergedPdfBlob = await mergePDFSFromUrls(labelUrls);
        const mergedUrls = URL.createObjectURL(mergedPdfBlob);
        window.open(mergedUrls, "_blank");
      } else {
        if (setErrorOnRetrieveData)
          setErrorOnRetrieveData("No hay etiquetas para descargar.");
      }
    } catch (error) {
      console.error(`Error al descargar las etiquetas: ${error}`);
      if (setErrorOnRetrieveData)
        setErrorOnRetrieveData("No hay etiquetas para descargar.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
  <Grid item xs={12} md={2} xl={2}>
      <div>
        <Button
          type="submit"
          variant="outlined"
          onClick={handleDownload}
          disabled={isLoading}
          startIcon={
            isLoading ? <CircularProgress size={20} color="inherit" /> : null
          }
        >
          <DownloadIcon fontSize="small" />
          {isLoading ? "Cargando..." : "Descargar etiquetas"}
          
        </Button>
      </div>
    </Grid>
  );
};

export default DownloadAllLabels;
